import { useState, useEffect } from 'react'
import styled from 'styled-components'

import { map } from 'lodash'

// hooks
import useLeaderboardScores from '../hooks/useLeaderboardScores'

import Cup from '../assets/champion.svg'

const WinnerBox = styled.div`
  img {
    margin-right: 0.4em;
    vertical-align: middle;
  }

  strong {
    font-weight: 800;
  }
`

const LeaderList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  
  li {
    padding: 0.3em 0;
    font-size: 0.9em;
    display: flex;
    align-items: center;
    gap: 0.8em;
  }
  
  li:first-child {
    padding: 0.3em 0 0.6em;
    font-size: 1.1em;
    font-weight: bold;
  }
`

const IconColumn = styled.span`
  flex-shrink: 0;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const PointsColumn = styled.span`
  flex-shrink: 0;
  width: 50px;
  font-weight: 600;
`

const UsersColumn = styled.span`
  flex: 1;
  word-break: break-word;
`

const ShowAllButton = styled.button`
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  font-size: 0.85em;
  text-decoration: underline;
  padding: 0.3em 0;
  margin-top: 0.3em;
  
  &:hover {
    color: white;
  }
`

const TOP_SCORES_COUNT = 1

const LeaderBoard = ({ postId, onVoteCount }) => {
  const [showAll, setShowAll] = useState(false)
  const { leaders, voteCount, loading, error } = useLeaderboardScores({ postId })

  // Pass vote count to parent in useEffect to avoid setState during render
  useEffect(() => {
    if (voteCount && onVoteCount) {
      onVoteCount(voteCount)
    }
  }, [voteCount, onVoteCount])

  if (loading) {
    return null
  }
  if (error) {
    return <div>{error}</div>
  }

  const displayedLeaders = showAll ? leaders : leaders.slice(0, TOP_SCORES_COUNT)
  const hasMore = leaders.length > TOP_SCORES_COUNT

  return (
    <WinnerBox>
      <LeaderList>
        {
          map(displayedLeaders, (leaderRecord, idx) => {
            return (
              <li key={`${leaderRecord.score}_leader`}>
                <IconColumn>{idx === 0 ? <img alt='championship-trophy-icon' src={Cup} width='32' height='32' /> : null}</IconColumn>
                <PointsColumn>{leaderRecord.score === '0' ? <span title='Abstained from ranking'>Abs.</span> : leaderRecord.score}</PointsColumn>
                <UsersColumn>{leaderRecord.users.join(', ')}</UsersColumn>
              </li>
            )
          })
        }
      </LeaderList>
      {hasMore && (
        <ShowAllButton onClick={() => setShowAll(!showAll)}>
          {showAll ? 'Show less' : `Show all ${leaders.length} scores`}
        </ShowAllButton>
      )}
    </WinnerBox>
  )
}

export default LeaderBoard
